module.exports = __webpack_public_path__ + "static/garden-and-kitchen-logo-30c391b80b7b0960ff414bbe85a773d3.svg";